import { LocationResource, VelavuFloor, VelavuSite } from "velavu-js-api";

export function getAvailableFloors() {
	const result: number[] = [];
	for (let i = 40; i >= -10; i--) {
		result.push(i);
	}
	return result;
}

/**
 * Gets a floor to target with an optional override value, defaulting the first above-ground floor
 */
export function getFloorTarget(
	floors: VelavuFloor[] | undefined,
	id: string | undefined,
): VelavuFloor | undefined {
	if (floors === undefined) {
		return undefined;
	} else if (id === undefined) {
		return (
			floors
				.sort((f1, f2) => f1.level - f2.level) //ascending order
				.find((floor) => floor.level >= 0) ?? floors[0]
		);
	} else {
		return floors.find((floor) => floor.id == id)!;
	}
}

/**
 * Gets the default floor number to offer to the user from a list of floor numbers
 */
export function getDefaultFloor(floors: number[]): number {
	//Return first above-ground floor
	const aboveFloors = floors.filter((floor) => floor > 0);
	if (aboveFloors.length > 0) return Math.min(...aboveFloors);

	//Return highest below-ground floor
	return Math.max(...floors);
}

/**
 * Gets all floors that the user can pick from for an existing site
 */
export function getAvailableSiteFloors(
	existingFloors: VelavuFloor[],
): number[] {
	return getAvailableFloors().filter(
		(floorNum) => !existingFloors.find((floor) => floor.level === floorNum),
	);
}

/**
 * Gets the floor_id attribute from an asset's location
 */
export function getLocationFloorID(
	location: LocationResource | undefined,
): string | undefined {
	if (location === undefined) {
		return undefined;
	} else if ("floor_id" in location) {
		return location.floor_id;
	} else {
		return undefined;
	}
}

/**
 * Gets the floor instance from a location resource
 * @param location The location resource to get the floor from
 * @param floors The list of floors to search
 * @returns The floor instance or undefined if not found
 */
export function getLocationFloorInstance(
	location: LocationResource | undefined,
	floors: VelavuFloor[] | undefined,
): VelavuFloor | undefined {
	//Get the floor ID from the location
	const floorID = getLocationFloorID(location);
	if (floorID === undefined) {
		return undefined;
	}

	//Look up the matching floor
	return floors?.find((floor) => floor.id === floorID);
}

/**
 * Returns whether a site's contents can be filtered by floor
 */
export function isSiteFloorFilterable(site: VelavuSite): boolean {
	return site.floors !== undefined && site.floors.length > 1;
}
